<template>
    <form autocomplete="off" class="container" id="setPassword">
        <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 mt-5">
            <img src="/img/logo.png" alt="KidsDay Logo" class="logo img-fluid mt-lg-4">

            <h2 class="mb-3">{{ trans('passwords.setup') }}</h2>

            <div class="row">
                <div class="col-md-7">
                    <div class="mb-4">
                        {{ trans('passwords.create_password_for_ur_acc') }}: <strong class="text-blue">{{ username }}</strong>
                    </div>

                    <FormErrorAlerts :errors="errors"></FormErrorAlerts>

                    <div class="d-flex flex-column gap-3">
                        <!-- PASSWORD -->
                        <basic-input
                            type="password"
                            left-icon="fi-rr-password"
                            :name="trans('general.page.reset_password.password')"
                            :label="trans('general.page.reset_password.password')"
                            :required="true"
                            :disabled="submitting"
                            v-on:reset-error="errorFields.password = null"
                            :error="errorFields.password"
                            v-model="password"/>

                        <!-- CONFIRM PASSWORD -->
                        <basic-input
                            type="password"
                            left-icon="fi-rr-password"
                            :name="trans('general.page.reset_password.password_confirm')"
                            :label="trans('general.page.reset_password.password_confirm')"
                            :required="true"
                            :disabled="submitting"
                            :help="trans('general.fields.password.help')"
                            v-on:reset-error="errorFields.password_confirmation = false"
                            :error="errorFields.password_confirmation"
                            v-model="password_confirmation"/>

                        <div class="col-12 item">
                            <div class="d-flex justify-content-between align-items-center mt-1">
                                <div class="form-check">
                                    <input v-model="terms_privacy" @click="errorFields.terms_privacy = null"
                                           class="form-check-input mt-0" type="checkbox" name="role" value="1"
                                           id="trial_rules_and_conditions_and_privacy_policy">
                                    <label class="form-check-label terms_privacy"
                                           for="trial_rules_and_conditions_and_privacy_policy"
                                           v-html="trans('general.defaults.accept_privacy_and_terms',{
                                    terms: `<a href='https://kidsday.com/en-us/terms-and-conditions' target='_new'>${trans('general.defaults.terms_and_conditions')}</a>`,
                                    privacy: `<a href='https://kidsday.com/en-us/privacy-policy' target='_new'>${trans('general.defaults.privacy_policy')}</a>`
                                })">
                                    </label>
                                    <div class="invalid-feedback d-block" v-if="errorFields.terms_privacy">
                                        {{ errorFields.terms_privacy }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <basic-button
                            :disabled="!validationStatus || !passwordsMatch"
                            :cls="formStatus === 'success' ? 'btn btn-success' : 'btn btn-new btn-primary'"
                            :icon="formStatus === 'success' ? 'fi fi-rr-check' : 'fi fi-rr-lock'"
                            :loading="submitting && formStatus !== 'success'"
                            :text="trans('passwords.create_new')"
                            @click="submitPassword"/>
                    </div>
                </div>
                <div class="col-md-5 mt-4 mt-lg-0">
                    <password-rules-validator
                        class="border-left-padding"
                        :validate="password ?? ''"
                        :passwords-match="passwordsMatch"
                        v-model="validationStatus"/>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import axios from "axios";
import BasicButton from "../atoms/BasicButton.vue";
import FormErrorAlerts from "../molecules/FormErrorAlerts.vue";
import {handleErrors} from "../../services/ErrorHandler";
import BasicInput from "../atoms/BasicInput.vue";
import BasicDatePicker from "../atoms/BasicDatePicker.vue";
import PasswordRulesValidator from "../atoms/PasswordRulesValidator.vue";

export default {
    name: "SetPassword",
    components: {
        BasicDatePicker,
        BasicInput,
        FormErrorAlerts,
        BasicButton,
        PasswordRulesValidator,
    },
    props: {
        email: {
            type: String,
            required: true,
        },
        username: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            password: null,
            password_confirmation: null,
            terms_privacy: false,
            submitting: false,
            formStatus: '',
            errors: [],
            errorFields: {
                password: null,
                password_confirmation: null,
                terms_privacy: null,
            },
            validationStatus: false,
        };
    },
    computed: {
        passwordsMatch: function () {
            return Boolean(
                this.password &&
                this.password_confirmation &&
                this.password === this.password_confirmation
            );
        }
    },
    methods: {
        handleErrors,
        submitPassword() {
            if (!this.terms_privacy) {
                this.errorFields.terms_privacy = trans('general.defaults.accept_terms_privacy_error');
                return;
            }

            this.submitting = true;

            const form = new FormData();
            form.append('username', this.username);
            form.append('password', this.password);
            form.append('password_confirmation', this.password_confirmation);

            axios.post(`/auth/create-password`, form)
                .then(response => {
                    this.formStatus = response.data.status;

                    this.$notify({
                        type: response.data.status,
                        title: response.data.message
                    });

                    if (response.data.status === 'success') {
                        setTimeout(function () {
                            window.location.reload();
                        }, 1500);
                    }
                })
                .catch(error => {
                    this.submitting = false;
                    handleErrors(error, this, this.errorFields);
                })
        }
    },
};
</script>

<style>
.logo {
    max-height: 85px;
    margin-bottom: 50px;
}

.input-icon {
    position: relative;
}

.input-icon input {
    padding-left: 45px !important;
}

.input-icon label {
    padding-left: 50px !important;
}

.input-icon .icon {
    position: absolute;
    left: 15px;
    top: 0;
    font-size: 20px;
    height: 100%;
}

.terms_privacy,
.terms_privacy a {
    font-size: 10px;
}

.terms_privacy {
    color: #a6a6a6;
}

.terms_privacy a:not(:hover) {
    color: #a6a6a6 !important;
}

@media (min-width: 768px) {
    .border-left-padding {
        margin-left: 1rem !important;
        padding-left: 1.5rem !important;
        border-left: 1px solid #e9ecef;
    }
}
</style>
